import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import styled from 'styled-components';
const OverlayWrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 4;
`;
export const Overlay = ({ children }) => {
    const modalRoot = document.getElementById('modal-root');
    if (!modalRoot)
        return null;
    return createPortal(_jsx(OverlayWrapper, { children: children }), modalRoot);
};
